
import ProdutoForm from "entity/Produto/components/ProdutoForm";
import ProdutoConsulta from "entity/Produto/components/ProdutoConsulta";
import BasicRoute from "components/routes/BasicRoute";

export default function RoutesMenusProduto() {


    return <>
        <BasicRoute uid='produto' route="produto" element={<ProdutoForm />} />
        <BasicRoute uid='consultaProduto' route="consulta-produto" perfilAuth='admin' menuProps={{
            text: "Produtos",
            sequence: "000006",
            iconName: "Category",
            parent: {
                uid: "CadastrosP",
                text: "Cadastros",
                iconName: "PlaylistAdd",
            },
        }} element={<ProdutoConsulta />} />
    </>;
}